import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cart-toolbar"
}
const _hoisted_2 = { class: "toolbar-left" }
const _hoisted_3 = {
  key: 0,
  class: "selected-hint"
}
const _hoisted_4 = { class: "toolbar-right" }
const _hoisted_5 = {
  key: 1,
  class: "cart-list"
}
const _hoisted_6 = { class: "cart-item-body" }
const _hoisted_7 = { class: "cart-item-row" }
const _hoisted_8 = { class: "cart-value" }
const _hoisted_9 = {
  key: 0,
  class: "cart-item-row"
}
const _hoisted_10 = { class: "cart-value" }
const _hoisted_11 = {
  key: 1,
  class: "cart-item-row"
}
const _hoisted_12 = { class: "cart-value" }
const _hoisted_13 = { class: "cart-item-row" }
const _hoisted_14 = { class: "cart-value" }
const _hoisted_15 = {
  key: 2,
  class: "cart-item-row"
}
const _hoisted_16 = { class: "cart-value" }
const _hoisted_17 = {
  key: 3,
  class: "cart-item-row"
}
const _hoisted_18 = { class: "cart-value" }
const _hoisted_19 = {
  key: 4,
  class: "cart-item-row"
}
const _hoisted_20 = { class: "cart-value" }
const _hoisted_21 = { class: "cart-item-row" }
const _hoisted_22 = { class: "cart-value" }
const _hoisted_23 = { class: "cart-item-actions" }
const _hoisted_24 = {
  key: 1,
  class: "cart-pagination"
}

import { computed, ref, watch } from "vue";
import { message } from "ant-design-vue";
import { deleteCartItem, getCartList, postCartBatchRemove } from "@/servers/api/cart";
import { useWrongQuestionCart } from "@/composables/useWrongQuestionCart";
import WrongQuestionDownloadModal from "./WrongQuestionDownloadModal.vue";

type CartItem = Record<string, any>;
type CartItemId = number | string;


export default /*@__PURE__*/_defineComponent({
  __name: 'WrongQuestionCartDrawer',
  props: {
    open: { type: Boolean },
    studentId: {},
    localItems: {}
  },
  emits: ["update:open", "update:localItems"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { decrementCount } = useWrongQuestionCart();

const cartItems = ref<CartItem[]>([]);
const cartTotal = ref(0);
const loading = ref(false);
const removing = ref(false);
const downloadOpen = ref(false);
const selectedIds = ref<CartItemId[]>([]);
const pagination = ref({ page: 1, size: 8 });
const text = (value: unknown) => String(value ?? "").trim();
const isLocalCart = computed(() => Array.isArray(props.localItems));

const itemKey = (item: CartItem): CartItemId => item.id || item.question_id || item.test_question_id || "";

const selectedItems = computed(() =>
  cartItems.value.filter((item) => selectedIds.value.includes(itemKey(item)))
);

const selectAll = computed({
  get: () => cartItems.value.length > 0 && selectedIds.value.length === cartItems.value.length,
  set: () => {},
});

const indeterminate = computed(
  () => selectedIds.value.length > 0 && selectedIds.value.length < cartItems.value.length
);

const loadLocalCart = (page = 1) => {
  const list = props.localItems ?? [];
  const total = list.length;
  const maxPage = Math.max(1, Math.ceil(total / pagination.value.size));
  const currentPage = Math.min(page, maxPage);
  const start = (currentPage - 1) * pagination.value.size;

  cartItems.value = list.slice(start, start + pagination.value.size);
  cartTotal.value = total;
  pagination.value.page = currentPage;
  selectedIds.value = [];
};

const loadCart = async (page = 1) => {
  if (isLocalCart.value) {
    loadLocalCart(page);
    return;
  }

  loading.value = true;
  selectedIds.value = [];
  try {
    const studentId = text(props.studentId);
    if (!studentId) throw new Error("缺少学生ID，无法查询购物车");
    const res = await getCartList({ student_id: studentId, page, size: pagination.value.size });
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "查询购物车失败");
    cartItems.value = Array.isArray(res?.data) ? res.data : [];
    cartTotal.value = Number(res?.total || cartItems.value.length);
    pagination.value.page = page;
  } catch (error: any) {
    cartItems.value = [];
    cartTotal.value = 0;
    message.error(error?.message || "加载购物车失败");
  } finally {
    loading.value = false;
  }
};

const handleSelectAll = () => {
  if (selectedIds.value.length === cartItems.value.length) {
    selectedIds.value = [];
  } else {
    selectedIds.value = cartItems.value.map(itemKey).filter((id) => id !== "");
  }
};

const toggleSelect = (id: CartItemId) => {
  const idx = selectedIds.value.indexOf(id);
  if (idx >= 0) {
    selectedIds.value.splice(idx, 1);
  } else {
    selectedIds.value.push(id);
  }
};

const removeLocalItems = (ids: CartItemId[]) => {
  const removeSet = new Set(ids.map(String));
  const next = (props.localItems ?? []).filter((item) => !removeSet.has(String(itemKey(item))));
  const maxPage = Math.max(1, Math.ceil(next.length / pagination.value.size));
  const currentPage = Math.min(pagination.value.page, maxPage);
  const start = (currentPage - 1) * pagination.value.size;

  emit("update:localItems", next);
  cartItems.value = next.slice(start, start + pagination.value.size);
  cartTotal.value = next.length;
  pagination.value.page = currentPage;
  selectedIds.value = [];
};

const handleRemove = async (item: CartItem) => {
  const id = itemKey(item);
  if (!id) return;

  if (isLocalCart.value) {
    removeLocalItems([id]);
    message.success("已移除");
    return;
  }

  try {
    const res = await deleteCartItem({ cart_id: Number(id) });
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "移除失败");
    cartItems.value = cartItems.value.filter((i) => itemKey(i) !== id);
    selectedIds.value = selectedIds.value.filter((selectedId) => selectedId !== id);
    cartTotal.value = Math.max(0, cartTotal.value - 1);
    decrementCount(1);
    message.success("已移除");
  } catch (error: any) {
    message.error(error?.message || "移除失败");
  }
};

const handleBatchRemove = async () => {
  if (!selectedIds.value.length) return;

  if (isLocalCart.value) {
    const removed = selectedIds.value.length;
    removeLocalItems([...selectedIds.value]);
    message.success(`已移除 ${removed} 项`);
    return;
  }

  removing.value = true;
  let removed = 0;
  try {
    for (const id of selectedIds.value) {
      try {
        const res = await deleteCartItem({ cart_id: Number(id) });
        if (Number(res?.code) === 200) removed++;
      } catch { /* skip */ }
    }
    decrementCount(removed);
    message.success(`已移除 ${removed} 项`);
    await loadCart(pagination.value.page);
  } catch {
    message.error("批量移除出错");
  } finally {
    removing.value = false;
  }
};

const handlePageChange = async (page: number) => {
  await loadCart(page);
};

const handleDownloadSuccess = async () => {
  const ids = [...selectedIds.value];
  if (!ids.length) return;

  if (isLocalCart.value) {
    removeLocalItems(ids);
    return;
  }

  try {
    const res = await postCartBatchRemove({ ids: ids.map(Number) });
    if (Number(res?.code) !== 200) {
      throw new Error(res?.msg || "下载后清空购物车失败");
    }

    decrementCount(ids.length);
    selectedIds.value = [];

    await loadCart(1);
  } catch (error: any) {
    message.warning(error?.message || "下载成功，但购物车清空失败，请手动移除");
  }
};

watch(
  () => props.open,
  (val) => {
    if (val) loadCart(1);
  }
);

watch(
  () => props.localItems,
  () => {
    if (props.open && isLocalCart.value) loadLocalCart(pagination.value.page);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: __props.open,
    title: "错题购物车",
    placement: "right",
    width: 720,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:open', false)))
  }, {
    default: _withCtx(() => [
      (cartTotal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_checkbox, {
                checked: selectAll.value,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
                indeterminate: indeterminate.value,
                onChange: handleSelectAll
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" 全选 ", -1)
                ]))]),
                _: 1
              }, 8, ["checked", "indeterminate"]),
              (selectedIds.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "已选 " + _toDisplayString(selectedIds.value.length) + " 项", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                danger: "",
                size: "small",
                disabled: !selectedIds.value.length,
                loading: removing.value,
                onClick: handleBatchRemove
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" 移除选中 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "loading"]),
              _createVNode(_component_a_button, {
                type: "primary",
                size: "small",
                disabled: !selectedIds.value.length,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadOpen.value = true))
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" 下载选中 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_spin, {
        spinning: loading.value,
        class: "cart-spin"
      }, {
        default: _withCtx(() => [
          (!cartTotal.value && !loading.value)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 0,
                description: "购物车为空，请先到错题页添加"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: itemKey(item),
                    class: _normalizeClass(["cart-item", { 'cart-item-selected': selectedIds.value.includes(itemKey(item)) }])
                  }, [
                    _createVNode(_component_a_checkbox, {
                      checked: selectedIds.value.includes(itemKey(item)),
                      class: "cart-item-check",
                      onChange: ($event: any) => (toggleSelect(itemKey(item)))
                    }, null, 8, ["checked", "onChange"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "cart-label" }, "题目ID", -1)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(item.test_question_id || item.question_id || '-'), 1)
                      ]),
                      (item.student_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "cart-label" }, "学生ID", -1)),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.student_id), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.class_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "cart-label" }, "班级ID", -1)),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.class_id), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "cart-label" }, "试卷ID", -1)),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.paper_id || item.test_paper_id || '-'), 1)
                      ]),
                      (item.question_number || item.string_number || item.question_key)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "cart-label" }, "题号", -1)),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(item.question_number || item.string_number || item.question_key), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.question_type)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "cart-label" }, "题型", -1)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.question_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.subject)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "cart-label" }, "科目", -1)),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(item.subject), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "cart-label" }, "加入时间", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(item.add_cart_time || item.create_time || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_a_button, {
                        type: "link",
                        danger: "",
                        size: "small",
                        onClick: ($event: any) => (handleRemove(item))
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("移除", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ], 2))
                }), 128))
              ]))
        ]),
        _: 1
      }, 8, ["spinning"]),
      (cartTotal.value > pagination.value.size)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_a_pagination, {
              size: "small",
              current: pagination.value.page,
              "page-size": pagination.value.size,
              total: cartTotal.value,
              "show-total": (total) => `共 ${total} 条`,
              onChange: handlePageChange
            }, null, 8, ["current", "page-size", "total", "show-total"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(WrongQuestionDownloadModal, {
        open: downloadOpen.value,
        "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((downloadOpen).value = $event)),
        total: selectedItems.value.length,
        "question-list": selectedItems.value,
        "student-id": __props.studentId,
        onDownloadSuccess: handleDownloadSuccess
      }, null, 8, ["open", "total", "question-list", "student-id"])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})